import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';

@Component({
  selector: 'app-join-code-input',
  templateUrl: './join-code-input.component.html',
  styleUrls: ['./join-code-input.component.scss'],
})
export class JoinCodeInputComponent implements AfterViewInit {
  readonly slots = [0, 1, 2, 3, 4, 5];

  @Output() codeChange = new EventEmitter<string>();

  @ViewChildren('digit') digitInputs!: QueryList<ElementRef<HTMLInputElement>>;

  ngAfterViewInit(): void {
    setTimeout(() => this.digitInputs?.first?.nativeElement.focus(), 0);
  }

  onInput(index: number, ev: Event): void {
    const input = ev.target as HTMLInputElement;
    const digits = input.value.match(/\d/g) ?? [];

    if (digits.length > 1) {
      this.fill(digits.slice(0, 6), index);
      return;
    }

    const next = digits[0] ?? '';
    if (input.value !== next) {
      input.value = next;
    }
    this.emit();
    if (next) this.focusAt(index + 1);
  }

  onKeydown(index: number, ev: KeyboardEvent): void {
    if (ev.key === 'Backspace') {
      const input = ev.target as HTMLInputElement;
      if (input.value === '') {
        ev.preventDefault();
        this.focusAt(index - 1, true);
      }
      return;
    }
    if (ev.key === 'ArrowLeft') {
      ev.preventDefault();
      this.focusAt(index - 1);
    } else if (ev.key === 'ArrowRight') {
      ev.preventDefault();
      this.focusAt(index + 1);
    }
  }

  onPaste(ev: ClipboardEvent): void {
    const text = ev.clipboardData?.getData('text') ?? '';
    const digits = (text.match(/\d/g) ?? []).slice(0, 6);
    if (digits.length === 0) return;
    ev.preventDefault();
    this.fill(digits, 0);
  }

  private fill(digits: string[], startIndex: number): void {
    if (!this.digitInputs) return;
    const inputs = this.digitInputs.toArray();
    digits.forEach((d, i) => {
      const target = inputs[startIndex + i];
      if (target) target.nativeElement.value = d;
    });
    this.emit();
    const targetIndex = Math.min(startIndex + digits.length, inputs.length - 1);
    this.focusAt(targetIndex);
  }

  private emit(): void {
    if (!this.digitInputs) return;
    const code = this.digitInputs
      .toArray()
      .map((r) => r.nativeElement.value)
      .join('');
    this.codeChange.emit(code);
  }

  private focusAt(index: number, clearAfter = false): void {
    if (!this.digitInputs) return;
    const inputs = this.digitInputs.toArray();
    if (index < 0 || index >= inputs.length) return;
    const el = inputs[index].nativeElement;
    el.focus();
    if (clearAfter) {
      el.value = '';
      this.emit();
    } else {
      setTimeout(() => el.select(), 0);
    }
  }
}
